export const message = {
  MyCredits: 'My Credits',
  confirm: 'Confirm',
  cancel: 'Cancel',
  home: {
    header: 'Game Credit Redemption',
    self_exchange: 'Self Exchange',
    beer_machine: 'Budweiser Draft Beer',
    prize_machine: 'Cages Gift',
    candy_machine: 'Cotton Candy',
    scan: 'Scan To Exchange',
    scan_loading: 'Identifying qr code',
    beer: 'Budweiser Draft Beer',
    prize: 'Cages Gift',
    candy: 'Cotton Candy',
    yohi_beer: '啤酒售货机',
    exchange: 'Use {price} tickets to exchange',
    exchange_success: 'Exchange success',
    exchange_beer_success: 'Please follow the instructions to receive Budweiser beer',
    exchange_goods_success: 'Please withdraw your goods',
    count_down: 'This page will close after ss seconds',
    prompt: '*From now on, you can earn credits by playing the game. Credits can be exchanged for gift and cotton candy machine for consumption. Please use them before expire',
    beer_prompt: 'Credits can be exchanged for draft beer at the Budweiser machine',
    prize_prompt: 'Credits can be exchanged for a variety of gifts at the gift machine',
    candy_prompt: 'Use credits to exchange cotton candy, and experience the fun of making cotton candy yourself',
    location: 'Location information to be added',
    beer_location_text: 'Work up a sweat playing these games?  Grab a Budweiser.  Just follow the directions on the machine to get yourself a cold one.',
    prize_location_text: 'Get cool prizes from the redemption prize machine -- big or small, Cages has something for you!',
    beer_confirm_title: 'Beer washer',
    beer_confirm_message: '{value}ml will be released at a time, do you confirm the execution？',
    wash_success: 'Wash Success',
    wechat_prize: 'Please use the Cages APP to exchange.'
  },
  about: {
    title: 'My credits',
    tickets: 'Tickets',
    rules: 'Rules',
    expire_prompt: 'The {num} tickets will expire on {date}. Please use them as soon as possible',
    income: 'Income',
    expenditure: 'Expenditure',
    no_more: 'No More',
    game_get_tickets: '{game}, Gain tickets',
    rank_get_tickets: '{game} score ranking, Gain tickets',
    history_rank_get_tickets: '{game} history ranking, Gain tickets',
    month_rank_get_tickets: '{game} month ranking, Gain tickets',
    week_rank_get_tickets: '{game} week ranking, Gain tickets',
    default_get_tickets: 'Gain tickets',
    cost_ticket: 'Exchange {name}',
    lucky_draw: 'Lucky Draw',
    rules_detail: 'With so many games at Cages, it\'s easier than ever to get tickets that you can use for fun (or delicious) prizes!  Use the Cages app to play games and collect tickets in participating games.  Don\'t forget to use your own account so that you can see who has the most tickets at the end of your night!'
  },
  lottery_list: {
    title: 'Records',
    code: 'Code',
    tickets: 'Tickets',
    status: {
      ready: 'No draw',
      no_win: 'No winning',
      win: 'Winning',
      has_change: 'Redeemed',
    },
    detail: 'Detail',
    label_code: 'Code: {code}',
    label_status: 'Status: {status}',
    winner_prompt: 'Congratulations on winning "{en_name}"',
    contact_staff: 'Please contact the staff to receive the prize',
    lottery_past: 'The drawing will be held on {date}. Please check it then',
    lottery_future: 'The drawing has been made on {date}',
    prize: '"{en_name}"',
    sn: 'No.{sn}',
    to_draw: 'Lucky Draw',
    notice: 'Congratulations to {encrypt_user_name} for winning the No.{sn} prize!',
    prize_previous: 'Previous ',
    prize_current: 'Prize ',
    prize_next: 'Next ',
    date: 'Date {date}',
    action_previous: 'Ended',
    action_previous_waiting: 'Waiting',
    action_current: 'Use {cost} Credits',
    action_next: 'Not Started',
    swipe_prompt: 'Slide to view previous/next draw',
    rule: 'Rules',
    prompt: 'Thank you for participating. The following is your lucky draw code. You can view it in the lucky draw record after closing the page'
  },
  lottery_rules: {
    title: 'Rules',
    list: [
      'Cages users can earn the credits through in-store game',
      'Draw on this page by consuming credits. Only once per issue',
      'After that, you can view the code and status on the records page',
      'After winning, please contact the staff in the store to verify the code and receive the prize',
      'The ultimate power of interpretation using personal influence originally time belongs to Cages',
    ],
    apple: 'Apple is not a sponsor'
  },
  errors: {
    qrcode: 'Invalid QR code',
    '1001' : 'Insufficient integral balance',
    '1002' : 'Beer machine is abnormal, payment failed',
    '1003' : 'No corresponding order was found',
    '1004' : 'Abnormal order status, please pay again',
    '1005' : 'No draw yet',
    '1006' : 'Lottery code did not win, please check and re-enter',
    '1007' : 'The lucky draw code has been claimed, please do not repeat',
    '1008' : 'Only once per issue',
    '1010' : 'Cotton candy machine is abnormal, payment failed',
    '1011': 'Cotton candy machine sn error',
    '1012': 'Ticket price error, please pay again',
    '1013': 'Beer machine is abnormal，device query failed',
    '1014': 'Beer machine is abnormal，order creation failed'
  },
  date_format: 'YYYY-MM-DD',
  coming_soon: 'COMING SOON'
}
